var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrap teacher-class"},[_c('div',{staticClass:"head"},[_c('h1',[_vm._v(_vm._s(_vm.$t('MY_LESSONS')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }